var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTireUnselected = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4098 71.5222C54.9661 71.5222 70.8196 55.6667 70.8196 36.1078C70.8196 16.5489 54.9661 0.693359 35.4098 0.693359C15.8535 0.693359 0 16.5489 0 36.1078C0 55.6667 15.8535 71.5222 35.4098 71.5222Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0988 25.2422L26.4876 31.8179C28.1469 33.2896 27.3016 36.0451 25.0787 36.2956L15.467 37.4228",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4494 17.8223L36.4733 26.8715C35.5966 28.9068 32.6849 28.9381 31.777 26.9028L27.7382 18.1041",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1325 35.862L44.3016 34.8913C42.0787 34.6721 41.1708 31.9479 42.7988 30.4136L49.9372 23.8379",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2012 54.4267L39.0723 44.7823C38.6026 42.5904 40.9194 40.8995 42.8606 41.9955L51.3139 46.755",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5653 47.8834L28.0812 42.8735C29.9911 41.7462 32.3392 43.4371 31.9009 45.5977L29.9911 55.0854",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4085 55.8681C46.3192 55.8681 55.1641 47.0221 55.1641 36.1099C55.1641 25.1976 46.3192 16.3516 35.4085 16.3516C24.4978 16.3516 15.653 25.1976 15.653 36.1099C15.653 47.0221 24.4978 55.8681 35.4085 55.8681Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4104 39.6176C37.347 39.6176 38.917 38.0474 38.917 36.1105C38.917 34.1737 37.347 32.6035 35.4104 32.6035C33.4738 32.6035 31.9039 34.1737 31.9039 36.1105C31.9039 38.0474 33.4738 39.6176 35.4104 39.6176Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4097 64.8532C51.283 64.8532 64.1508 51.9837 64.1508 36.1083C64.1508 20.2329 51.283 7.36328 35.4097 7.36328C19.5364 7.36328 6.66858 20.2329 6.66858 36.1083C6.66858 51.9837 19.5364 64.8532 35.4097 64.8532Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.58638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTireUnselected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tire_unselected.7697295f.svg";
export { ForwardRef as ReactComponent };